import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export function createApollo(httpLink: HttpLink) {
  return {
    link: httpLink.create({
      uri: environment.graphqluri,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    }),
    cache: new InMemoryCache(),
  };
}

export const apolloProvider = {
  provide: APOLLO_OPTIONS,
  useFactory: createApollo,
  deps: [HttpLink],
};
